import translations from "module/translations/en";

export default translations;
